export default "__VITE_ASSET__CfH0pb5Q__"